import { colors } from '~/layout';
import * as lib from '~/dependencies';

export const Container = lib.styled.div`
  height: ${(props: any) =>
    props.maxHeight === 'auto' ? props.maxHeight : `${props.maxHeight}px`};
  overflow-x: scroll;

  .list--header {
    position: relative!important;
    top: 0px!important;
    background-color: ${colors.white};
    margin: 5px 0px 5px 0px!important;

    .line-header {
      position: relative!important;
      top: 0px!important;
      margin: 0!important;
    }
  }
`;

export const CenterMessage = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 70% !important;
  height: 600px;
  color: ${colors.darkGray02} !important;
`;
